<template>
    <div class="eachars-box weekAnalysis">
      <el-row>
        <el-col :span="12">
          <span class="eachars-title">周数据统计</span>
        </el-col>
      </el-row>
      <div id="weekAna" :style="{width: '100%', height: '300px'}"></div>
    </div>
</template>
<script>
import { getProgramPlayByWeek } from '@/resource/api/dataAnalysis'
export default {
  data () {
    return {
      form: {
        createBy: this.$store.state.router.createBySuffix,
        platform: this.$store.state.router.cpcode
      },
      setDataOption: {}
    }
  },
  mounted () {
    this.pageInit() // 初始化数据
  },
  methods: {
    pageInit () {
      this.weeksData() // 周数据统计
    },
    weeksData () { // 周数据统计
      // 绘制图表
      getProgramPlayByWeek(this.form).then((res) => {
        if (res && res.code == 1) {
          this.setDataOption = {
            xAxis: {
              data: res.result.xAxis.data
            },
            series: [
              {
                data: res.result.series[0].data
              },
              {
                data: res.result.series[1].data
              }
            ]
          }
          // that.echartBox.setOption(setDataOptin)
          // 基于准备好的dom，初始化echarts实例
          const myChart = this.$echarts.init(document.getElementById('weekAna'))
          // 绘制图表
          myChart.setOption({
            title: {},
            tooltip: { // 提示框 component
              trigger: 'axis',
              backgroundColor: '#fff',
              textStyle: { color: '#66697', fontSize: 7, lineHeight: 25 },
              axisPointer: { type: 'cross', label: { backgroundColor: '#6a7985' } }
            },
            legend: {
              right: '5%',
              icon: 'rect',
              itemWidth: 12,
              itemHeight: 4,
              textStyle: { color: '#2C3542' },
              data: ['节目集播放量', '节目播放量']
            },
            grid: { // 直角坐标系的底板 component
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true,
              tooltip: { borderColor: '#f0f' }
            },
            xAxis: [
              {
                type: 'category',
                boundaryGap: false,
                axisLabel: { color: '#666978' },
                axisLine: { lineStyle: { color: 'rgba(0, 0, 0, 0.45)', width: 1, type: 'solid' } },
                data: this.setDataOption.xAxis.data
              }
            ],
            yAxis: [
              {
                name: '数量',
                type: 'value',
                splitLine: { lineStyle: { type: 'dashed' } }, // 网格线
                axisLine: { lineStyle: { color: 'rgba(0, 0, 0, 0.45)', width: 1, type: 'solid' } },
                axisLabel: { color: '#666978' },
                nameTextStyle: { color: 'rgba(0, 0, 0, 0.45)' }
              }
            ],
            series: [
              {
                name: '节目播放量',
                type: 'line',
                data: this.setDataOption.series[0].data,
                itemStyle: { color: '#3FD4FF' }
              },
              {
                name: '节目集播放量',
                type: 'line',
                data: this.setDataOption.series[1].data,
                itemStyle: { color: '#FCA52C' }
              }
            ]
          })
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
  @import "../../../../assets/css/dataAnalysis.less";
</style>
